import React from "react";
import Select from "react-select";
import { Link } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";
import EventStore from "../stores/EventStore";
import EventActions from "../actions/EventActions";
import VenueStore from "../stores/VenueStore";
import VenueActions from "../actions/VenueActions";
import TagStore from "../stores/TagStore";
import TagActions from "../actions/TagActions";

import AnalyticsHeader from "./partials/analytics-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import StatsBlockContainer from "./partials/stats-block-container.jsx";
import StatsBlock from "./partials/stats-block.jsx";

import AttendeeAnalyticsTable from "./partials/attendee-analytics-table.jsx";
import FromCacheCallout from "./partials/from-cache-callout.jsx";

import { formatNumber } from "../util";

class AttendeeAnalytics extends React.Component {
  static getStores() {
    return [EventBucketStore, EventStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    const eventState = EventStore.getState(),
      venueState = VenueStore.getState(),
      tagState = TagStore.getState();

    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      events: eventState.events,
      venues: venueState.venues,
      tags: tagState.tags,
      isFetching:
        eventState.isFetching || venueState.isFetching || tagState.isFetching,
      getEventsForEventBucket: EventStore.getEventsForEventBucket,
      getAttendeeAnalytics: AnalyticsStore.getAttendeeAnalytics
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentDidMount() {
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (
      force === true ||
      newProps.params.eventBucketId !== this.props.params.eventBucketId
    ) {
      AnalyticsActions.fetchAttendeeAnalytics.defer(
        newProps.params.eventBucketId
      );
      EventActions.fetchAllForBucket.defer(newProps.params.eventBucketId);
      VenueActions.fetchAllForBucket.defer(newProps.params.eventBucketId);
      TagActions.fetchAllForBucket.defer(newProps.params.eventBucketId);
      EventBucketActions.fetchOne.defer(newProps.params.eventBucketId);
    }
  }

  render() {
    const { eventBucketId } = this.props.params,
      eventBucket = this.props.getEventBucketById(eventBucketId),
      { events, tags, venues, isFetching } = this.props,
      eventBucketEvents = this.props.getEventsForEventBucket(eventBucketId),
      attendeeAnalytics = this.props.getAttendeeAnalytics(eventBucketId);

    if (
      !attendeeAnalytics ||
      !eventBucket ||
      (eventBucketEvents.length === 0 && isFetching)
    ) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <AnalyticsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label="attendee analytics"
          subpath="attendees"
        />
        <FromCacheCallout analytics={attendeeAnalytics} />
        <p>
          Scroll down to view attendance <a href="#by-event">by event</a>,{" "}
          <a href="#by-venue">by venue</a>, <a href="#by-tag">by tag</a>, and{" "}
          <a href="#by-date">by date</a>.
        </p>
        <StatsBlockContainer style={{ marginTop: -10 }}>
          <StatsBlock
            value={formatNumber(attendeeAnalytics.unique_count)}
            label={
              <span>
                Unique attendees{" "}
                <a
                  href="https://help.eventive.org/analyzing-your-data/what-are-unique-attendees"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  (?)
                </a>
              </span>
            }
          />
          <StatsBlock
            value={formatNumber(attendeeAnalytics.unique_used_count)}
            /*subvalue={`${(attendeeAnalytics.unique_used_count / attendeeAnalytics.unique_count * 100).toFixed(2)}%)`}*/
            label="Unique scanned attendees"
          />
          <StatsBlock
            value={formatNumber(attendeeAnalytics.total_count)}
            label="Tickets issued"
          />
          <StatsBlock
            value={formatNumber(attendeeAnalytics.total_used_count)}
            /*subvalue={`${(attendeeAnalytics.total_used_count / attendeeAnalytics.total_count * 100).toFixed(2)}%`}*/
            label="Tickets scanned"
          />
        </StatsBlockContainer>
        <a className="anchor--fixed_header_offset" id="by-event" />
        <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
          Attendance by event (scanned / total)
        </h2>
        <AttendeeAnalyticsTable
          eventBucket={eventBucket}
          events={events}
          data={attendeeAnalytics.by_event}
        />
        <a className="anchor--fixed_header_offset" id="by-venue" />
        <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
          Attendance by venue (scanned / total)
        </h2>
        <AttendeeAnalyticsTable
          eventBucket={eventBucket}
          venues={venues}
          events={events}
          groupBy="venue"
          data={attendeeAnalytics.by_event}
        />
        <a className="anchor--fixed_header_offset" id="by-tag" />
        <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
          Attendance by tag (scanned / total)
        </h2>
        <AttendeeAnalyticsTable
          eventBucket={eventBucket}
          tags={tags}
          events={events}
          groupBy="tag"
          data={attendeeAnalytics.by_event}
        />
        <a className="anchor--fixed_header_offset" id="by-date" />
        <h2 style={{ marginTop: "1em", marginBottom: "0.5em" }}>
          Attendance by date (scanned / total)
        </h2>
        <AttendeeAnalyticsTable
          eventBucket={eventBucket}
          tags={tags}
          events={events}
          groupBy="date"
          data={attendeeAnalytics.by_event}
        />
      </div>
    );
  }
}

export default connectToStores(AttendeeAnalytics);



// WEBPACK FOOTER //
// ./src/app/components/attendee-analytics.jsx